// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__i24uH","list":"Input_list__Vs2GV"};